import { Action } from '@ngrx/store';
import { SelfDiagnosticStepModel } from './model';

export enum ActionTypes {
  FAILURE = '[SelfDiagnosticStep] Failure',

  GET_STEP_REQUEST = '[SelfDiagnosticStep] Get step Request',
  GET_STEP_SUCCESS = '[SelfDiagnosticStep] Get step Success',

  SET_SELECTED_REQUEST = '[SelfDiagnosticStep] SetSelected Request',
  SET_SELECTED_SUCCESS = '[SelfDiagnosticStep] SetSelected Success',
}

export class FailureAction implements Action {
  readonly type = ActionTypes.FAILURE;
  constructor(public error: string) {}
}

export class GetStepRequestAction implements Action {
  readonly type = ActionTypes.GET_STEP_REQUEST;
  constructor(
    public serviceId: number,
    public page: number
  ) {}
}

export class GetStepSuccessAction implements Action {
  readonly type = ActionTypes.GET_STEP_SUCCESS;
  constructor(public item: SelfDiagnosticStepModel) {}
}

export class SetSelectedRequestAction implements Action {
  readonly type = ActionTypes.SET_SELECTED_REQUEST;

  constructor(public model: SelfDiagnosticStepModel) {}
}

export class SetSelectedSuccessAction implements Action {
  readonly type = ActionTypes.SET_SELECTED_SUCCESS;

  constructor(public model: SelfDiagnosticStepModel) {}
}

export type Actions = FailureAction | GetStepRequestAction | GetStepSuccessAction | SetSelectedRequestAction | SetSelectedSuccessAction;
